import React from "react";
import { FaHeartbeat } from "react-icons/fa";

const HeartbeatECGLoader = () => {
  return (
    <>
      <div className="flex flex-col items-center justify-center h-[80vh] text-red-600">
        {/* Pulsing Heart */}
        <div className="relative text-7xl">
          <FaHeartbeat className="animate-heart-beat drop-shadow-xl" />
          <div className="absolute inset-0 rounded-full blur-md bg-red-400/30 animate-heart-fill z-[-1]" />
        </div>

        {/* ECG Line */}
        <svg
          className="mt-8 w-[250px] h-[60px]"
          viewBox="0 0 250 60"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <polyline
            className="stroke-current text-red-500 animate-ecg-line"
            strokeWidth="2"
            fill="none"
            points="0,30 20,30 25,20 30,40 35,30 60,30 65,10 70,50 75,30 250,30"
          />
        </svg>

        <p className="mt-6 text-lg font-semibold animate-pulse text-red-500">
        Loading health articles...
        </p>
      </div>

      {/* Tailwind Custom Animations */}
      <style>
        {`
          @keyframes heart-beat {
            0%, 100% { transform: scale(1); }
            50% { transform: scale(1.2); }
          }

          .animate-heart-beat {
            animation: heart-beat 1.5s ease-in-out infinite;
          }

          @keyframes heart-fill {
            0%, 100% { opacity: 0.3; transform: scale(0.9); }
            50% { opacity: 0.6; transform: scale(1.2); }
          }

          .animate-heart-fill {
            animation: heart-fill 1.5s ease-in-out infinite;
          }

          @keyframes ecg-line {
            0% { stroke-dashoffset: 500; }
            100% { stroke-dashoffset: 0; }
          }

          .animate-ecg-line {
            stroke-dasharray: 500;
            stroke-dashoffset: 500;
            animation: ecg-line 2s linear infinite;
          }
        `}
      </style>
    </>
  );
};

export default HeartbeatECGLoader;
